<template>
  <section>
    <nav-component
      :titulo="'Clientes'"
      :link="{ path: '/agregar-cliente' }"
      :texto="'Agregar cliente'"
    />
    <!-- Encima de la tabla -->
    <div class="buttons mb-4">
      <b-button
        type="is-success"
        icon-left="upload"
        @click="$refs.fileInput.click()"
      >
        Importar clientes
      </b-button>
      <input
        ref="fileInput"
        type="file"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        style="display: none"
        @change="procesarArchivo"
      />
    </div>

    <b-table :data="clientes">
      <b-table-column
        field="nombre"
        label="Nombre del cliente"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.nombre }}
      </b-table-column>

      <b-table-column
        field="telefono"
        label="Teléfono"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.telefono }}
      </b-table-column>

      <b-table-column
        field="placa"
        label="placa"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.placa }}
      </b-table-column>

      <b-table-column
        field="categoria"
        label="categoria"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.nombreCategoria }}
      </b-table-column>
      <b-table-column field="eliminar" label="Eliminar" v-slot="props">
        <b-button
          type="is-danger"
          icon-left="delete"
          @click="eliminar(props.row.id, props.row.nombre)"
          >Eliminar</b-button
        >
      </b-table-column>
      <b-table-column field="editar" label="Editar" v-slot="props">
        <b-button type="is-info" icon-left="pen" @click="editar(props.row.id)"
          >Editar</b-button
        >
      </b-table-column>
    </b-table>
    <div v-if="cargando" class="overlay-loader">
      <div class="loader-content">
        <b-icon
          icon="cloud-upload"
          size="is-large"
          custom-class="has-text-white"
        ></b-icon>
        <p>{{ mensajeCarga }}</p>
      </div>
    </div>
  </section>
</template>
<script>
import NavComponent from "../Extras/NavComponent";
import HttpService from "../../Servicios/HttpService";
import Swal from "sweetalert2";

export default {
  name: "ClientesComponent",
  components: { NavComponent },

  data: () => ({
    cargando: false,
    clientes: [],
    historial: {},
    historialFiltrado: {},
    mensajeCarga: "", // Nuevo mensaje de carga
  }),

  mounted() {
    this.obtenerClientes();
    document.title = "Clientes";
  },

  methods: {
    async eliminar(idCliente, nombreCliente) {
      const result = await Swal.fire({
        title: "Eliminar cliente",
        text: `¿Seguro que quieres eliminar a ${nombreCliente}? Esta acción no se puede revertir.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      });

      if (result.isConfirmed) {
        this.cargando = true;
        HttpService.eliminar("clientes.php", {
          accion: "eliminar",
          id: idCliente,
        })
          .then((resultado) => {
            this.cargando = false;
            if (!resultado) {
              Swal.fire("Error", "Error al eliminar", "error");
              return;
            }

            Swal.fire(
              "Eliminado",
              `Cliente ${nombreCliente} eliminado.`,
              "success"
            );
            this.obtenerClientes();
          })
          .catch((error) => {
            this.cargando = false;
            Swal.fire("Error", "Error al eliminar", error);
          });
      }
    },
    async procesarArchivo(event) {
      const archivo = event.target.files[0];
      if (!archivo) return;

      const formData = new FormData();
      formData.append("archivo", archivo);
      formData.append("accion", "importar");

      // Mostrar Swal de carga
      Swal.fire({
        title: "Importando...",
        html: "Por favor espera mientras se suben los datos.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const response = await fetch("../../mensajes/api/subirCsv.php", {
          method: "POST",
          body: formData,
        });

        const resultado = await response.json();
        Swal.close(); // Cerrar el Swal de carga

        if (resultado.status === "success") {
          Swal.fire(
            "¡Importado!",
            `${resultado.importados} cliente(s) añadidos.`,
            "success"
          );
          this.obtenerClientes();
        } else {
          throw new Error(resultado.error || "Error desconocido.");
        }
      } catch (error) {
        Swal.close();
        Swal.fire("Error", error.message, "error");
      }
    },

    editar(idCliente) {
      this.$router.push({
        name: "EditarCliente",
        params: { id: idCliente },
      });
    },

    obtenerClientes() {
      // Método para obtener la lista de clientes
      this.cargando = true;
      let payload = {
        accion: "obtener",
      };

      HttpService.obtenerConConsultas("clientes.php", payload).then(
        (clientes) => {
          this.clientes = clientes;
          this.cargando = false;
        }
      );
    },
  },
};
</script>

<style scoped>
.overlay-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7); /* Fondo oscuro */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader-content {
  text-align: center;
  color: white;
  font-size: 1.2rem;
}
</style>

